import { getTimeSeverityFromCrewDutyRanges } from './getTimeSeverityFromCrewDutyRanges';

import type { AircraftData } from '#entities';

export const getAircraftTimeSeverity = (aircraftData: AircraftData) =>
  getTimeSeverityFromCrewDutyRanges(aircraftData.dutyRanges);
